import type {RouteRecordRaw} from "vue-router";

import {EPermissao} from "@/core/type/permissao.type";

export const pedidoCompraRoutes: RouteRecordRaw[] = [
    {
        path: "/pedido-compra",
        name: "pedido-compra",
        meta: {authRequired: true, permissao: EPermissao.CGR_PRISMA_LISTAR_PEDIDO_COMPRA},
        component: () => import("@/modules/pedidoCompra/pages/PagePedidoCompra.vue")
    },
];
